import { apiService } from '@/api/apiService';
import { ApiResponseType } from '@/types/sharedTypes';
import { SecureLinkVerifyStatusType } from '@/types/myVaultTypes';

export const getSecureLinkVerificationStatusApi = (
  token: string
): Promise<ApiResponseType<SecureLinkVerifyStatusType>> => {
  return apiService.GET(`/secure-links/${token}/verify/status/`);
};
